/* ============================================================
   VORRYX Animations v1.0
   IntersectionObserver-based scroll animations
   Lightweight (<2KB minified)
   ============================================================ */
(function() {
  'use strict';

  /* ---- Scroll-triggered fade-up ---- */
  function initFadeUp() {
    var els = document.querySelectorAll('.fade-up');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ---- Staggered children animation ---- */
  function initStagger() {
    var containers = document.querySelectorAll('.fade-up-stagger');
    if (!containers.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var children = entry.target.querySelectorAll('.fade-up');
          children.forEach(function(child, i) {
            setTimeout(function() {
              child.classList.add('visible');
            }, i * 80);
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -20px 0px'
    });

    containers.forEach(function(c) {
      observer.observe(c);
    });
  }

  /* ---- Animated number counter ---- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-vx-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(el) {
      observer.observe(el);
    });
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-vx-counter'), 10);
    if (isNaN(target)) return;

    var suffix = el.getAttribute('data-vx-suffix') || '';
    var prefix = el.getAttribute('data-vx-prefix') || '';
    var duration = 1200;
    var start = performance.now();

    function step(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      /* easeOutQuart */
      var ease = 1 - Math.pow(1 - progress, 4);
      var current = Math.round(ease * target);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  /* ---- Parallax on mouse move (optional, for hero) ---- */
  function initParallax() {
    var layers = document.querySelectorAll('[data-vx-parallax]');
    if (!layers.length) return;

    document.addEventListener('mousemove', function(e) {
      var x = (e.clientX / window.innerWidth - 0.5) * 2;
      var y = (e.clientY / window.innerHeight - 0.5) * 2;

      layers.forEach(function(layer) {
        var depth = parseFloat(layer.getAttribute('data-vx-parallax')) || 10;
        var moveX = x * depth;
        var moveY = y * depth;
        layer.style.transform = 'translate(' + moveX + 'px, ' + moveY + 'px)';
      });
    });
  }

  /* ---- Initialize ---- */
  function init() {
    initFadeUp();
    initStagger();
    initCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
